import React, { createContext, useEffect } from "react";
import { toast } from "react-toastify";
import { handleGetBlogs, handleGetCaseStudies } from "../service/service";
import { BlogType, CaseStudy } from "../types/types";

export interface DataContextType {
  blogs: BlogType[];
  caseStudy: CaseStudy[];
  setCaseStudy: React.Dispatch<React.SetStateAction<CaseStudy[]>>;
  setBlogs: React.Dispatch<React.SetStateAction<BlogType[]>>;
  currentBlogPage: number;
  totalBlogPages: number;
  currentCaseStudyPage: number;
  totalCaseStudyPages: number;
  handleCaseStudyPageChange: (page: number) => void;
  handleBlogPageChange: (page: number) => void;
  loading: boolean;
}

const DataContext = createContext<DataContextType>({
  blogs: [],
  caseStudy: [],
  setCaseStudy: () => {},
  setBlogs: () => {},
  currentBlogPage: 1,
  totalBlogPages: 1,
  currentCaseStudyPage: 1,
  totalCaseStudyPages: 1,
  handleCaseStudyPageChange: () => {},
  handleBlogPageChange: () => {},
  loading: false,
});

const DataProvider = ({ children }: any) => {
  const [blogs, setBlogs] = React.useState<BlogType[]>([]);
  const [caseStudy, setCaseStudy] = React.useState<CaseStudy[]>([]);

  const [currentBlogPage, setCurrentBlogPage] = React.useState(1);
  const [totalBlogPages, setTotalBlogPages] = React.useState(1);
  const [currentCaseStudyPage, setCurrentCaseStudyPage] = React.useState(1);
  const [totalCaseStudyPages, setTotalCaseStudyPages] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  const limit = 9;

  const handleBlogPageChange = (page: number) => {
    if (page >= 1 && page <= totalBlogPages) {
      setCurrentBlogPage(page);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCaseStudyPageChange = (page: number) => {
    console.log(page);
    if (page >= 1 && page <= totalCaseStudyPages) {
      setCurrentCaseStudyPage(page);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const getCaseStudies = async () => {
      try {
        setLoading(true);
        const caseStudies = await handleGetCaseStudies(
          currentCaseStudyPage,
          limit,
        );
        if (caseStudies.status === 200) {
          setCaseStudy(caseStudies.data as CaseStudy[]);
          setTotalCaseStudyPages(caseStudies.meta.pagination.pageCount);
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        toast.error("Something went wrong");
      }
    };

    const getBlogs = async () => {
      try {
        setLoading(true);
        const blogs = await handleGetBlogs(currentCaseStudyPage, limit);
        if (blogs.status === 200) {
          setBlogs(blogs.data as BlogType[]);
          setTotalBlogPages(blogs.meta.pagination.pageCount);
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        toast.error("Something went wrong");
      }
    };

    getCaseStudies();
    getBlogs();

    console.log(currentBlogPage, currentCaseStudyPage);
  }, [currentBlogPage, currentCaseStudyPage]);

  return (
    <DataContext.Provider
      value={{
        blogs,
        caseStudy,
        totalCaseStudyPages,
        totalBlogPages,
        currentCaseStudyPage,
        setCaseStudy,
        currentBlogPage,
        loading,
        handleBlogPageChange,
        handleCaseStudyPageChange,
        setBlogs,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };
